/** Standard verse counts per chapter (18 chapters) — fallback when API omits verseCount. */
export const GITA_VERSES_PER_CHAPTER = {
  1: 47,
  2: 72,
  3: 43,
  4: 42,
  5: 29,
  6: 47,
  7: 30,
  8: 28,
  9: 34,
  10: 42,
  11: 55,
  12: 20,
  13: 35,
  14: 27,
  15: 20,
  16: 24,
  17: 28,
  18: 78,
};

export function verseCountForChapter(chapterNumber) {
  return GITA_VERSES_PER_CHAPTER[chapterNumber] ?? null;
}
